
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import PrinterListWindow from '@/components/windows/PrinterListWindow.vue';
import PrinterListHeader from '@/components/jobDetailed/printerList/PrinterListHeader.vue';
import PrinterListLoadBody from '@/components/jobDetailed/printerList/PrinterListLoadBody.vue';

@Component({
  components: {
    PrinterListWindow,
    PrinterListHeader,
    PrinterListLoadBody,
  },
})
export default class PrinterListDialog extends Vue {
  @Prop(String) public title: string;
  @Prop(Function) public printRequest: (printerId: number) => Promise<AxiosResponse>;
  @Prop(Boolean) public isShow: boolean;
  @Prop(Function) public close: () => void;

  public dialog = false;

  @Watch('isShow', { immediate: true })
  private watchIsShow(isShow: boolean) {
    this.dialog = isShow;
  }

  public handleInput(dialog: boolean) {
    if (!dialog) {
      this.close();
    }
  }
}
